import { render, staticRenderFns } from "./Inventory-settings.vue?vue&type=template&id=87ac782c&scoped=true"
import script from "./Inventory-settings.vue?vue&type=script&lang=js"
export * from "./Inventory-settings.vue?vue&type=script&lang=js"
import style0 from "./Inventory-settings.vue?vue&type=style&index=0&id=87ac782c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ac782c",
  null
  
)

export default component.exports